import http from 'services/http';

interface CreateUserResourceViewParams {
  resourceId: string;
  resourceType: string;
}

export async function createUserResourceView(params: CreateUserResourceViewParams) {
  return http.post<void>(`/user_resource_views`, params);
}
